var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoText = function SvgLogoNoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1202 1202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M682 712.3H375.9V265H682C787.1 265 872.2 350.2 872.2 455.2V522C872.2 627.1 787.1 712.3 682 712.3Z",
    fill: "#ACD905"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M760.9 936H375.9V712.3C375.9 588.8 476 488.7 599.5 488.7H760.9C884.4 488.7 984.5 588.8 984.5 712.3C984.5 835.8 884.4 936 760.9 936Z",
    fill: "#AEAFAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M872.2 518.4V522.1C872.2 627.2 787.1 712.3 681.9 712.3H375.9C375.9 650.6 401 594.7 441.4 554.2C481.9 513.7 537.8 488.7 599.6 488.7H760.9C801.5 488.7 839.5 499.5 872.2 518.4Z",
    fill: "#5D6E3C"
  })));
};
export default SvgLogoNoText;